import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { API_URL, securityHeaders } from '../Constants';

/*****************Fetch type by id */
const fetchDropdownTypes = async (typeId) => {
  if (typeId) {
    return await axios.get(API_URL + `/api/Settings/GetDrowDown/${typeId}`, {
      headers: securityHeaders,
    });
  }
};

export const useFetchDropDownTypes = (typeId) => {
  return useQuery({
    queryKey: [`Types-${typeId}`],
    queryFn: () => fetchDropdownTypes(typeId),
    enabled: true,
  });
};
/*********************Fetch all types */
const fetchAllTypes = async () => {
  return await axios.get(API_URL + '/api/Settings/GetDrowDownTypes', {
    headers: securityHeaders,
  });
};
export const useFetchAllTypes = () => {
  return useQuery({
    queryKey: ['AllTypes'],
    queryFn: () => fetchAllTypes(),
    enabled: true,
  });
};

/*************************Fetch according to type and  parent */
const fetchRelatedToType = async (type, parentId) => {
  if (parentId) {
    return await axios.get(
      API_URL + `/api/Settings/GetDrowDownFromParent/${type}/${parentId}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchRelatedToType = ({ type, parentId }) => {
  return useQuery({
    queryKey: ['RelatedTypes', type, parentId],
    queryFn: () => fetchRelatedToType(type, parentId),
    enabled: true,
  });
};
/*****************Add Types */

const addValuesForTypes = ({
  typeID,
  value,
  Text_EN,
  Text_AR,
  parentId,
  brochureLink,
  applicationsCS,
}) => {
  const parentIdParam = parentId !== undefined ? `parentId=${parentId}` : '';
  const brochureLinkParam =
    brochureLink !== undefined ? `BrochureLink=${brochureLink}` : '';
  const applicationsCSParam =
    applicationsCS !== undefined ? `ApplicationsCS=${applicationsCS}` : '';

  return axios.post(
    API_URL +
      `/api/DropDown/SetDropDown/${typeID}/${value}/${Text_AR}?${parentIdParam}&${brochureLinkParam}&${applicationsCSParam}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useAddValuesForType = () => {
  return useMutation(addValuesForTypes);
};

/********************Get Field Of Interest */
const fetchFieldOfInterest = async () => {
  return await axios.get(API_URL + '/api/Settings/GetFieldOfInterest', {
    headers: securityHeaders,
  });
};
export const UseFetchFieldOfInterest = () => {
  return useQuery({
    queryKey: ['fieldOfInterest'],
    queryFn: () => fetchFieldOfInterest(),
    enabled: false,
  });
};
/********************Get Field Of Interest by application start*/
const fetchFieldOfInterestByApplicationStart = async (applicationStart) => {
  if (applicationStart !== undefined) {
    return await axios.get(
      API_URL +
        `/api/Settings/GetFieldOfInterestByApplicationStart/${applicationStart}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchFieldOfInterestByAppStart = (applicationStart) => {
  return useQuery({
    queryKey: ['fieldOfInterestByApplicationStart'],
    queryFn: () => fetchFieldOfInterestByApplicationStart(applicationStart),
    enabled: true,
  });
};
/************Add Term */
const addTerm = (values) => {
  return axios.post(API_URL + `/api/Term/PostAcademicTerms`, values, {
    headers: securityHeaders,
  });
};

export const useAddTerm = () => {
  return useMutation(addTerm);
};

/***********Get all  Terms */
const fetchTerms = async () => {
  return await axios.get(API_URL + '/api/Term/AcademicTerms', {
    headers: securityHeaders,
  });
};
export const useFetchTerms = () => {
  return useQuery({
    queryKey: ['allTerms'],
    queryFn: () => fetchTerms(),
    enabled: true,
  });
};

/***********Get Terms */
const fetchAcademicYears = async () => {
  return await axios.get(API_URL + '/api/Settings/GetAcademicYears', {
    headers: securityHeaders,
  });
};
export const useFetchAcademicYears = () => {
  return useQuery({
    queryKey: ['academicYears'],
    queryFn: () => fetchAcademicYears(),
    enabled: true,
  });
};

/********Delete Term */
const deleteTerm = (termId) => {
  return axios.post(
    API_URL + `/api/Settings/DeleteAcademicTerm/${termId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteTerm = () => {
  return useMutation(deleteTerm);
};

/**********Edit Dropdown */
const editValueForTypes = ({
  typeID,
  Text_EN,
  Text_AR,
  brochureLink,
  applicationsCS,
}) => {
  const brochureLinkParam =
    brochureLink !== undefined ? `BrochureLink=${brochureLink}` : '';
  const applicationsCSParam =
    applicationsCS !== undefined ? `ApplicationsCS=${applicationsCS}` : '';

  return axios.post(
    API_URL +
      `/api/DropDown/EditDropDown/${typeID}/${Text_EN}/${Text_AR}?${brochureLinkParam}&${applicationsCSParam}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useEditValuesForTypes = () => {
  return useMutation(editValueForTypes);
};

///delete settings option
const deleteSettingsOption = (settingsId) => {
  return axios.post(
    API_URL + `/api/DropDown/DeleteDropDownOption/${settingsId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteSettingsOption = () => {
  return useMutation(deleteSettingsOption);
};

////export dropdown options
const exportDropDownOptionsTable = async (type, typeName) => {
  return await axios.get(
    API_URL + `/api/Export/ExportDropDownOptions/${type}/${typeName}`,
    {
      headers: securityHeaders,
      responseType: 'blob',
    }
  );
};
export const useExportDropDownOptionsTable = (type, typeName) => {
  return useMutation(() => exportDropDownOptionsTable(type, typeName));
};

const fetchPositions = async () => {
  return await axios.get(API_URL + '/api/Settings/GetPositions', {
    headers: securityHeaders,
  });
};
export const useFetchPositions = () => {
  return useQuery({
    queryKey: ['positions'],
    queryFn: () => fetchPositions(),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};
const encodePath = (v) => encodeURIComponent(String(v ?? ''));

const savePosition = ({ positionId, positionEN, positionAR }) => {
  return axios.post(
    API_URL +
      `/api/Settings/Positions/${encodePath(positionId)}/${encodePath(
        positionEN
      )}/${encodePath(positionAR)}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useSavePosition = () => {
  return useMutation(savePosition);
};
const deletePosition = (positionId) => {
  return axios.post(
    API_URL + `/api/Settings/DeletePosition/${positionId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeletePosition = () => {
  return useMutation(deletePosition);
};
